import { render, staticRenderFns } from "./LocalizationTabList.vue?vue&type=template&id=2b5ae499"
import script from "./LocalizationTabList.vue?vue&type=script&lang=js"
export * from "./LocalizationTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports